import { ResolutionDetailPage } from '@/components/governance/resolution-detail-page'

export function AdminResolutionDetail() {
  return <ResolutionDetailPage basePath="/admin/polls" />
}
